import type { SVGProps } from "react";
import * as React from "react";

const SvgDollarSign = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M13 1a1 1 0 1 0-2 0zm-2 22a1 1 0 1 0 2 0zm6-17a1 1 0 1 0 0-2zM6 8.5H5zM9.5 12v1zm5 0v-1zm0 7v1zM6 18a1 1 0 1 0 0 2zm5-17v22h2V1zm6 3H9.5v2H17zM9.5 4a4.5 4.5 0 0 0-3.182 1.318l1.414 1.414A2.5 2.5 0 0 1 9.5 6zM6.318 5.318A4.5 4.5 0 0 0 5 8.5h2a2.5 2.5 0 0 1 .732-1.768zM5 8.5a4.5 4.5 0 0 0 1.318 3.182l1.414-1.414A2.5 2.5 0 0 1 7 8.5zm1.318 3.182A4.5 4.5 0 0 0 9.5 13v-2a2.5 2.5 0 0 1-1.768-.732zM9.5 13h5v-2h-5zm5 0a2.5 2.5 0 0 1 1.768.732l1.414-1.414A4.5 4.5 0 0 0 14.5 11zm1.768.732A2.5 2.5 0 0 1 17 15.5h2a4.5 4.5 0 0 0-1.318-3.182zM17 15.5a2.5 2.5 0 0 1-.732 1.768l1.414 1.414A4.5 4.5 0 0 0 19 15.5zm-.732 1.768A2.5 2.5 0 0 1 14.5 18v2a4.5 4.5 0 0 0 3.182-1.318zM14.5 18H6v2h8.5z"
    />
  </svg>
);
export default SvgDollarSign;
